import { Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { SpanWithEllipsisAndTooltipOnOverflow, api, getQueryProps, parseError } from 'common';

interface PracticeLabelProps {
  practiceId: string;
}

export function PracticeLabel(props: PracticeLabelProps) {
  const { practiceId } = props;

  const {
    data: practice,
    isPending,
    error,
    isError,
  } = useQuery({
    ...getQueryProps(api.client.Practice, 'findOneBasicById', practiceId),
    retry: false,
  });

  if (isPending) {
    return <Skeleton variant="text" width={128} />;
  }

  if (isError) {
    return <span>{parseError(error).includes('not found') ? practiceId : 'Error'}</span>;
  }

  return (
    <SpanWithEllipsisAndTooltipOnOverflow placement="right">
      {practice.name}
    </SpanWithEllipsisAndTooltipOnOverflow>
  );
}
